module.exports = __webpack_public_path__ + "static/media/banner1.d48c61e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/images/banner1.jpg
// module id = 95
// module chunks = 0